import { createHighContrastTheme } from "../../utils/createHighContrastTheme.js";
export const teamsHighContrastTheme = createHighContrastTheme();
